const TODO_COLUMN_NAME = 'todo'
const INPROCESS_COLUMN_NAME = 'inProcess'
const DONE_COLUMN_NAME = 'done'
const ALL_TASKS = 'tasks'

export const DIALOG_ADD_NEW_TASK = 'dialogAddNewTask'
export const DIALOG_EDIT_TASK = 'dialogEditTask'
export const DIALOG_REMOVE_TASK = 'dialogRemoveTask'

export { ALL_TASKS, TODO_COLUMN_NAME, INPROCESS_COLUMN_NAME, DONE_COLUMN_NAME }
